import { cn } from '../../lib/utils';

export function LogoMark({ className }) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
      className={cn('shrink-0 overflow-visible', className)}
    >
      <path
        fill="currentColor"
        d="M8 10h42c4.97 0 9 4.03 9 9 0 10.49-8.51 19-19 19h-5v18H23V38H8V27h32c4.42 0 8-3.58 8-8H8v-9Z"
      />
      <circle cx="49" cy="48" r="6" fill="#D6A23A" />
    </svg>
  );
}

export function Wordmark({ className, title = 'Toxy' }) {
  return (
    <svg
      viewBox="0 0 125 48"
      fill="currentColor"
      role="img"
      aria-label={title}
      className={cn('h-5 w-auto', className)}
    >
      <path d="M3 8h28v7H20v25h-7V15H3V8Z" />
      <path
        fillRule="evenodd"
        d="M47 41c-9 0-15-6.3-15-15s6-15 15-15 15 6.3 15 15-6 15-15 15Zm0-7c4.7 0 7.8-3.3 7.8-8S51.7 18 47 18s-7.8 3.3-7.8 8 3.1 8 7.8 8Z"
        clipRule="evenodd"
      />
      <path d="M64 12h8.1l6.1 8.7 6.2-8.7h7.8l-9.8 13.7L93 40h-8.2l-6.7-9.3-6.7 9.3h-7.9l10.7-14.2L64 12Z" />
      <path d="M95 12h8.2l7 16.2L117 12h7.6l-13 29c-2.3 5.2-5.2 7-10 7h-5.1v-6.3h4.4c2 0 3.2-.8 4.1-2.7l.6-1.3L95 12Z" />
    </svg>
  );
}
